var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{attrs:{"items":_vm.methodOptions,"item-text":"label","item-value":"value","label":_vm.labelText,"rules":_vm.rules,"clearable":_vm.clearable},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }